export default __webpack_public_path__ + "static/media/illust_self_assessment.b6418a48.svg";